import { createTheme } from '@mantine/core';

export const theme = createTheme({
  defaultRadius: 'sm',
  fontWeights: {
    medium: '500',
  },
  primaryColor: 'gray',
  fontFamily: '"Helvetica Now Display", Arial, sans-serif',
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
  },
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.25rem',
  },
  headings: {
    sizes: {
      h1: {
        fontSize: '1.5rem',
      },
      h2: {
        fontSize: '1.25rem',
      },
    },
  },
  components: {
    Text: {
      styles: {
        root: {
          fontSize: 'var(--mantine-font-size-sm)',
        },
      },
    },
  },
  colors: {
    gray: [
      '#f5f5f5',
      '#e7e7e7',
      '#cdcdcd',
      '#b2b2b2',
      '#9a9a9a',
      '#8b8b8b',
      '#848484',
      '#717171',
      '#656565',
      '#262626',
    ],
    blue: [
      '#e6f3ff',
      '#cfe2ff',
      '#a0c3fb',
      '#6ca1f7',
      '#4285f3',
      '#2773f2',
      '#1167f2',
      '#0459d8',
      '#004fc2',
      '#0044ac',
    ],
    layout: [
      '#262626', // 0: Background Top Bar
      '#2D2C2C', // 1: Background Side Bar
      '#F7F7F7', // 2: Background Content
      '#191919', // 3: Background Content Header 1
      '#313131', // 4: Background Content Header 2
      '#9FA6B2', // 5: Icon Search Icon
      '#757575', // 6: Placeholder Search
      '#9D9D9D', // 7: Icons Top Bar and Logo Inactive
      '#9FA6B2', // 8: Logo Active
      '#9FA6B2', // 9: Icons Side Bar
      '#6D6D6D', // 10: Tooltip Icons Side Bar
      '#383636', // 11: Background Active Navigation Link
    ],
    text: [
      '#FFFFFF', // 0: Content Header
      '#4F4F4F', // 1: Content Description
      '#1266F1', // 2: Content Tab Names
      '#4F4F4F', // 3: Content
      '#D3D3D3', // 4: Page Title
      '#9D9D9D', // 5: User Name
      '#C9C9C9', // 6: User Name Hover
      '#000',
      '#000',
      '#000',
    ],
  },
});
